/*
 * @Author: sam
 * @Date: 2021-06-26 14:13:13
 * @LastEditTime: 2021-07-11 18:42:01
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /bagels.2/src/components/Input/index.js
 */

import { makeStyles } from '@material-ui/core/styles';
import styled from 'styled-components'
import Input from '@material-ui/core/Input';


const useStyles = makeStyles((theme) => ({
    input: {
        padding: '.2rem',
        color: '#fff',
        fontWeight: 600,
        fontSize: '2rem',
        borderRadius: '12px',
        // border: '1px solid rgba(255,255,255,0.08)',
    },
    // focused: {
    //     fontFamily: 'Montserrat script=latin rev=1 !important'
    // }
  }));

  
function InputBlock({before, after, className, input={}, ...other}) {
    const classes = useStyles()
    return (
        <Block className={className} {...other}>
            {before}
            <Input
                {...input}
                classes={classes}
                style={{color: input.readOnly?'#c6c6c6':'#fff',paddingLeft:'4px'}}
                // classes={classes}
                disableUnderline={true} 
            />
            {after}
        </Block>
    )
}

export default InputBlock

const Block = styled.div`
    /* background-color: rgba(0,0,0,0.2); */
    /* background-color: rgba(2,10,26,0.6); */
    /* background-color: rgba(254,184,98,0.2); */
    /* background-color: rgba(44,136,232,0.5); */
    background-color: rgba(45,45,45,0.2);
    width: max-content;
    padding: .6rem .6rem;
    border-radius: 12px;
    border: 1px solid rgba(255,255,255,0.08);
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    width: 100%;
    /* border-radius: 100px; */
    .MuiInputBase-root {
        width: 100%;
    }
`
